import React, { SVGProps } from 'react';

const SvgC02 = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width='1em'
			height='1em'
			viewBox='0 0 19 9'
			fill='none'
			className='svg-icon'
			xmlns='http://www.w3.org/2000/svg'
			{...props}>
			<path
				d='M8 6C7.71667 6 7.47933 5.904 7.288 5.712C7.096 5.52067 7 5.28333 7 5V1C7 0.716667 7.096 0.479 7.288 0.287C7.47933 0.0956664 7.71667 0 8 0H11C11.2833 0 11.521 0.0956664 11.713 0.287C11.9043 0.479 12 0.716667 12 1V5C12 5.28333 11.9043 5.52067 11.713 5.712C11.521 5.904 11.2833 6 11 6H8ZM8.5 4.5H10.5V1.5H8.5V4.5ZM1 6C0.716667 6 0.479333 5.904 0.288 5.712C0.0960001 5.52067 0 5.28333 0 5V1C0 0.716667 0.0960001 0.479 0.288 0.287C0.479333 0.0956664 0.716667 0 1 0H4C4.28333 0 4.521 0.0956664 4.713 0.287C4.90433 0.479 5 0.716667 5 1V2H3.5V1.5H1.5V4.5H3.5V4H5V5C5 5.28333 4.90433 5.52067 4.713 5.712C4.521 5.904 4.28333 6 4 6H1ZM14 9V6.5C14 6.21667 14.096 5.979 14.288 5.787C14.4793 5.59567 14.7167 5.5 15 5.5H17V4.5H14V3H17.5C17.7833 3 18.0207 3.09567 18.212 3.287C18.404 3.479 18.5 3.71667 18.5 4V5.5C18.5 5.78333 18.404 6.02067 18.212 6.212C18.0207 6.404 17.7833 6.5 17.5 6.5H15.5V7.5H18.5V9H14Z'
				fill='#F00D69'
			/>
		</svg>
	);
};

export default SvgC02;
